import { render, staticRenderFns } from "./TheLanguageSwitcher.vue?vue&type=template&id=527b5278&scoped=true"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TheLanguageSwitcher.vue?vue&type=style&index=0&id=527b5278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b5278",
  null
  
)

export default component.exports